import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { message, Modal } from 'antd'
import { useValidateAuth } from '~/hooks/useValidateAuth'

import { FOLLOW, UN_FOLLOW } from '~/graphqls/gqls'
import {
  PostTypes,
  follow,
  followVariables,
  followCancel,
  followCancelVariables,
  FollowStatus,
} from '~/graphqls/types'
import { useStores } from '~/hooks/useStores'
/** 关注 */
const statusDesc = {
  [FollowStatus.NON]: { text: '关注', type: 'primary' },
  [FollowStatus.HE_ONE_WAY]: { text: '关注', type: 'primary' },
  [FollowStatus.ME_ONE_WAY]: { text: '已关注', type: 'default' },
  [FollowStatus.TWO_WAY]: { text: '互相关注', type: 'default' },
}
export const usePostFollow = (
  post: PostTypes,
  {
    onChange,
  }: {
    onChange?: (status: FollowStatus) => void
  } = {}
) => {
  const { store } = useStores()
  const [loading, setLoading] = useState(false)
  const status = post?.user?.social?.followStatus
  const [followAction] = useMutation<follow, followVariables>(FOLLOW)
  const [unFollowAction] = useMutation<followCancel, followCancelVariables>(
    UN_FOLLOW
  )
  const { validateIsLogin } = useValidateAuth()
  const postUserId = post?.user?.uid

  const isSelf = postUserId === store.userinfo?.base?.uid

  const handleFollow = async () => {
    try {
      setLoading(true)
      const res = await followAction({
        variables: {
          param: {
            followUid: postUserId,
          },
        },
      })
      if (res.data?.status) {
        let nextStatus: FollowStatus = FollowStatus.NON
        switch (status) {
          case FollowStatus.NON:
            nextStatus = FollowStatus.ME_ONE_WAY
            break
          case FollowStatus.HE_ONE_WAY:
            nextStatus = FollowStatus.TWO_WAY
            break
          case FollowStatus.ME_ONE_WAY:
            // never
            nextStatus = FollowStatus.ME_ONE_WAY
            break
          case FollowStatus.TWO_WAY:
            // never
            nextStatus = FollowStatus.TWO_WAY
            break
        }
        onChange?.(nextStatus)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleUnFollow = async () => {
    let resolveP: any
    let rejectP: any
    const confirmPromise = new Promise((resolve, reject) => {
      resolveP = resolve
      rejectP = reject
    })
    Modal.confirm({
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: `hookModal dark`,
      content: (
        <div className="text-neutral-400 text-sm text-center">
          确认不再关注？
        </div>
      ),
      okText: '提交',
      onOk: close => {
        resolveP()
        close()
      },
      onCancel: close => {
        rejectP()
        close()
      },
    })
    try {
      await confirmPromise
    } catch (err) {
      return
    }

    try {
      setLoading(true)
      const res = await unFollowAction({
        variables: {
          param: {
            followUid: postUserId,
          },
        },
      })
      if (res.data?.status) {
        let nextStatus: FollowStatus = FollowStatus.NON
        switch (status) {
          case FollowStatus.NON:
            nextStatus = FollowStatus.NON
            break
          case FollowStatus.HE_ONE_WAY:
            nextStatus = FollowStatus.HE_ONE_WAY
            break
          case FollowStatus.ME_ONE_WAY:
            nextStatus = FollowStatus.NON
            break
          case FollowStatus.TWO_WAY:
            nextStatus = FollowStatus.HE_ONE_WAY
            break
        }
        onChange?.(nextStatus)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleClick = () => {
    if (!validateIsLogin()) {
      return
    }

    if (isSelf) {
      message.destroy()
      message.error('不能关注自己')
      return
    }

    if (status === FollowStatus.ME_ONE_WAY || status == FollowStatus.TWO_WAY) {
      handleUnFollow()
    } else {
      handleFollow()
    }
  }

  let buttonText = '关注'
  let buttonType = 'default'
  if (status && statusDesc[status]) {
    buttonText = statusDesc[status].text
    buttonType = statusDesc[status].type
  }
  return {
    buttonText,
    buttonType,
    buttonLoading: loading,
    handleClick,
  }
}
